<template>
  <nav class="navbar" role="card-actions" aria-label="card-edit">
    <div class="navbar-menu">
      <div class="navbar-start ml-2" @click.prevent="goBack()">
        <a
          class="navbar-item is-size-3 is-paddingless has-text-weight-bold has-background-white"
        >
          {{ config.backBtnText }}
        </a>
      </div>

      <div class="navbar-end" >
        <div class="navbar-item" v-if="hasProjects">
          <IconField :rowData="card" :setVerticalLine="setVerticalLine"
          :rowField="{ id: 'lmvIcon'}" :projects="allProjects" :isCardSubHeader="true"/>
        </div>
        <div class="is-divider-vertical" v-if="verticalLine"></div>
        <div class="navbar-item" v-for="btn in config.actions" :key="btn">
          <button
            :class="icons[btn]"
            class="button has-text-black-bis"
            @click="actionsClicked(btn)" v-tooltip="getButtonTooltip(btn)"
          ></button>
        </div>
         <div class="is-divider-vertical ml-0 mr-0" v-if="!hideActions"></div>
        <div class="navbar-item" v-if="!hideActions">
          <figure class="image is-48x48" >
          </figure>
        </div>
      </div>
    </div>
    <notify-users
      v-if="showNotify"
      :isActive="showNotify"
      :card="card"
      @close="showNotify = false"
    >
    </notify-users>
  </nav>
  <activity-log
                :id="activityDetail.id"
                :projectId="activityDetail.projectId"
                :isActive="isActive"
                :type = "module"
                :orderName="activityDetail.orderName"
                @update:isActive="isActive=false"></activity-log>
</template>

<script>
import { reactive, toRefs,  onBeforeMount, computed, onMounted } from 'vue';
import {
  keys, pickBy, cloneDeep, unset,
  flatMap,
} from 'lodash';
import { useRouter } from 'vue-router';
import ActivityLog from '@/components/ActivityLog.vue';
import CardEditMixin from '@/components/mixins/CardEditMixin';
import NotifyUsers from '@/components/modals/NotifyUsers.vue';
import IconField from '../../components/fields/IconField.vue';
import Projects from '../../models/Projects'
import { useStore } from 'vuex';
import Subscriptions from '@/models/Subscriptions';
import { useToast } from 'vue-toastification';

export default {
  name: 'CardEditSubHeader',
  components: {
    ActivityLog,
    NotifyUsers,
    IconField
  },
  props: {
    type: String,
    module: String,
    stage: String,
    card: {
      type: Object,
      default: () => ({}),
    },
    status: String,
    hideActions: {
      default: false,
      type: Boolean,
    },
  },
  setup(props) {
    const store = useStore();
    const { card, status } = props;
    const router = useRouter();
    const toast = useToast();
    const { getConfigDetails, printQr, printShipQr, openLmvModel } = CardEditMixin();
    const state = reactive({
      isActive: false,
      config: {},
      activityDetail: {
        id: '',
        projectId: '',
        activityDetail: '',
      },
      icons: {
        activity: 'icon-activityhistory',
        notifyUsers: 'icon-notifyusers',
        save: 'icon-checkmark',
        subscribe: 'icon-unsusbscribe',
        qrPrint: 'icon-qrcode',
      },
      showNotify: false,
      isSubscribed: false,
      verticalLine: false,
      allProjects: [],
    });

    const shippingStages = ['not-started', 'in-transit', 'complete', 'delivery', 'released-to-inventory',
      'fulfilled', 'in-storage', 'mixed-shipping', 'un-scheduled'];

    const goBack = () => {
      let path = '/home';
      if (store.state.activeScreen === 'qc-formBuilder-template-edit') {
        router.push({ path: '/settings/company/templates/qcFormTemplates' });
        return;
      }
      if (store.state.activeScreen === 'formBuilder-template-edit') {
        router.push({ path: '/settings/company/templates/formTemplates' });
        return;
      }
      const backUrl = {
        Materials: [...shippingStages, 'mixed', 'rejected'].includes(card._customStage) ? '/materials/preparation' : `/materials/${card._customStage}`,
        Prefabs: '/prefab/planning',
        // eslint-disable-next-line no-nested-ternary
        ProductionOrder: !card.isManager ? '/prefab/coordination' : [...shippingStages, 'mixed'].includes(card._customStage) ? '/manager/manufacturing' : `/manager/${card._customStage}`,
        Sourcing: shippingStages.includes(card.stage) ? '/materials/ordering' : `/materials/${card.stage}`,
        ProdTemplates: '/settings/company/templates/prodTemplates',
        MatTemplates: '/settings/company/templates/matTemplates'
      };

      if (store.state.activeScreen === 'project-view') router.push({ path: '/settings' })

      if (card?.type === 'pick' || card?.type === 'stock') path = '/logistics/transfer-request';
      else if ([...shippingStages, 'mixed', 'consumed', 'zombie'].includes(status)) {
        path = '/logistics/shipping/order-view';
      } else if (props.type === 'kit-view-edit') {
        if (window.history.length) {
          router.go(-1);
          return;
        }
      } else {
        path = backUrl[card.__t];
      }
      router.push({ path });
    };
    // eslint-disable-next-line max-len
    const configDetails = cloneDeep(getConfigDetails(props.type, props.card.__t, props.card._customStage || props.card.stage)) || {};
    state.config = configDetails.cardSubHeader;
    if (['complete', 'delivery'].includes(props.card._customStage || props.card.stage));
    else if (!['material-edit-ordering', 'manager-edit-detailing', 'manager-edit-manufacturing', 'manager-edit-qa', 'shipping-edit', 'shipping-card-edit'].includes(props.type)) {
      unset(state.config.actions, 'qrPrint');
    }
    state.config.actions = keys(pickBy(state.config.actions));
    const actionsClicked = async (btn) => {
      // do actions based on btn click;
      if (btn === 'activity') {
        state.isActive = true;
        const routeParams = router.currentRoute.value.params;
        state.activityDetail.id = routeParams.cardId || routeParams?.requestId;
        state.activityDetail.projectId = routeParams.projectId;
        state.activityDetail.orderName = card.name;
      } 
      if (btn === 'notifyUsers') {
        state.showNotify = true;
      } else if (btn === 'qrPrint') {
        if (props.type === 'shipping-card-edit') {
          printShipQr(card);
        } else printQr(card);
      } else if(btn === 'subscribe') {
        let subscribeObj = {
          cardId: card._id,
          projectId: card.project._id,
          __t: card.__t,
        }
        try {
          if(state.isSubscribed){
            await Subscriptions.unSubscribeFromCard(subscribeObj);
            state.isSubscribed = false;
            state.icons.subscribe = 'icon-unsusbscribe';
            toast.warning('Unsubscribed: you will not be notified when this Order changes');
          } else{
            await Subscriptions.cardSubscriptions(subscribeObj);
            state.isSubscribed = true;
            state.icons.subscribe = 'icon-subscribe';
            toast.success('Subscribed: you will be notified when this Order changes');
          }
        } catch (error) {
          console.error('error', error);
          toast.error('Error while Subscribing');
        }
      }
    };
    const hasProjects = computed(() => {
      return state.allProjects.length;
      });
    const setVerticalLine = (hasGuid) => {
      state.verticalLine = hasGuid;
    };
    onMounted (async () =>{
     let isSub = await Subscriptions.getSubscriptionValue(
      {
        cardId: card._id,
        projectId: card.project?._id,
        __t: card.__t,
      });
     if (isSub.data.isProjectSub) {
        state.isSubscribed = isSub.data.isProjectSub;
     } else {
        state.isSubscribed = isSub.data.cardCount > 0;
     }
     if(state.isSubscribed) {
       state.icons.subscribe = 'icon-subscribe';
    } else {
      state.icons.subscribe = 'icon-unsusbscribe';
     }
  });
  onBeforeMount(async () => {
      try {
          const projectId = _.get(props.card.project, '_id', '');
          const project = store.getters.findProject({ _id: projectId });
          if (_.isUndefined(project)) {
            state.allProjects = await Projects.allProjects();
          } else {
            state.allProjects = store.state.queryParams._projects;
          }        
      } catch (error) {
        console.error("Error fetching projects:", error);
        state.errorMessage = "Failed to load projects. Please try again later.";
      }
    });
    const getButtonTooltip = (btn) => {
      const tooltipObj = {
        'icon-subscribe' : 'Subscribed',
        'icon-unsusbscribe' : 'Unsubscribed'
      };
      if (btn === 'subscribe' ) return tooltipObj[state.icons[btn]];
      return ''
    }
    return {
      ...toRefs(state),
      actionsClicked,
      goBack,
      hasProjects,
      getButtonTooltip,
      setVerticalLine,
    };
  },
};
</script>

<style scoped>
.is-48x48 {
  width: 55px !important;
}
</style>
